import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Alert, AlertTitle } from '@packages/fenrir/components';
import { Snackbar } from '@packages/fenrir/components/snackbar';

export const ErrorSnackbar = ({
  isError,
  message,
}: {
  isError: boolean;
  message: string;
}) => {
  const { t } = useTranslation('riskManagement', {
    keyPrefix: 'risks.notifications',
  });

  const [showError, setShowError] = useState<boolean>(isError);

  useEffect(() => {
    setShowError(isError && message.length > 0);
  }, [isError, message]);

  return (
    <Snackbar
      open={showError}
      autoHideDuration={5000}
      onClose={() => setShowError(false)}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Alert
        variant="standard"
        severity="error"
        onClose={() => setShowError(false)}
      >
        <AlertTitle>{t('requestFailed')}</AlertTitle>
        {message}
      </Alert>
    </Snackbar>
  );
};
